export default __webpack_public_path__ + "static/media/fr.40c79af5.svg";